module.exports = __webpack_public_path__ + "img/exam.3fdf457f.svg";